export const PLATE_REGEX = /^[A-Z]{3}\d(?:\d{3}|[A-Z]\d{2})$/;

export default function plate(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (PLATE_REGEX.test(value)) {
    return false;
  }

  return true;
}

plate.message = function message(value, options = {}) {
  return options.message || 'não é uma placa válida';
};
